import { ActionContext, ActionTree } from 'vuex';
import { IRootState } from '@/store/state';
import Snackbar from '@/models/Snackbar';
import * as MT from './mutationTypes';
import * as AT from './actionTypes';
import {
  ValidateUserDetailsRequest,
  ValidatedUserDetails,
  AcknowledgeSubmissionRequest
} from '@/types';
import { AppService } from '../service';
/**
 * --------------------------------------------------
 *	Root Actions
 * --------------------------------------------------
 **/
export const RootActions: ActionTree<IRootState, IRootState> = {
  [AT.DISPLAY_SNACKBAR]: (context: IRootActionContext, snackbar: Snackbar) =>
    context.commit(MT.SET_SNACKBAR, {
      status: true,
      ...snackbar
    }),
  [AT.VALIDATE_USER_DETAILS]: (
    context: IRootActionContext,
    validateUserDetailsRequest: ValidateUserDetailsRequest
  ) => {
    return AppService.validateUserDetails(validateUserDetailsRequest).then(
      (result: ValidatedUserDetails) => {
        return result;
      }
    );
  },
  [AT.ACKNOWLEDGE_SUBMISSION_REQUEST]: (
    context: IRootActionContext,
    acknowledgeSubmissionRequest: AcknowledgeSubmissionRequest
  ) => {
    return AppService.acknowledgeSubmissionRequest(
      acknowledgeSubmissionRequest
    ).then(res => res);
  }
};
/**
 * --------------------------------------------------
 *	Root Action Context Interface
 * --------------------------------------------------
 **/
export interface IRootActionContext
  extends ActionContext<IRootState, IRootState> {}
/**
 * --------------------------------------------------
 *	Root Action (Tree) Interface
 * --------------------------------------------------
 **/
export interface IRootActions extends ActionTree<IRootState, IRootState> {
  [AT.DISPLAY_SNACKBAR](context: IRootActionContext, snackbar: Snackbar): void;
  [AT.VALIDATE_USER_DETAILS](
    context: IRootActionContext,
    validateUserDetailsRequest: ValidateUserDetailsRequest
  ): void;
  [AT.ACKNOWLEDGE_SUBMISSION_REQUEST](
    context: IRootActionContext,
    acknowledgeSubmissionRequest: AcknowledgeSubmissionRequest
  ): void;
}
